module.exports = __webpack_public_path__ + "img/HSE-sub-team.610af017.png";